import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { catchError, materialize, switchMap } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { GoogleClass } from 'src/app/_models/googleClassroom/google-class';
import { ClassroomService } from 'src/app/_services/classroom.service';

@Component({
  selector: 'app-unidad-form-classroom-select',
  standalone: false,
  templateUrl: './unidad-form-classroom-select.component.html',
  styleUrls: ['./unidad-form-classroom-select.component.scss']
})
export class UnidadFormClassroomSelectComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  materia: any;

  @Input()
  courses: GoogleClass[];

  @Input()
  actual;

  @Input()
  editable: boolean;

  classroomSelectForm = new UntypedFormGroup({
    classroomSelect: new UntypedFormControl(0)
  });;

  autorizado: boolean;

  savingSubject = new BehaviorSubject(true);
  notSaving$ = this.savingSubject.asObservable();

  valueChangesSubscription: Subscription;

  constructor(
    private classroomService: ClassroomService,
    private customAlertService: CustomAlertService,
    private snackBar: MatSnackBar
    ) { }

  ngOnInit(): void {
    // TODO: probar con respuesta real de una persona que no tiene acceso.
    this.materia.course = this.materia.course || null;
    // this.materia.course = null;
    this.actual = this.actual || 0;
    this.autorizado = this.actual !== 0 ? (this.courses.findIndex(item => +item.id === +this.materia.classroomCourseId || +item.id === this.actual) > -1  ? true : false) : true;
    this.classroomSelectForm.setValue({classroomSelect: this.actual}, {emitEvent: false});

    this.valueChangesSubscription = this.classroomSelectForm.get('classroomSelect').valueChanges.pipe(
      switchMap(data => {
        this.savingSubject.next(false);
        const accion = +data !== 0;
        return this.enlazarRequest([this.materia], accion, data);
      }),
    ).subscribe(res => {
      this.savingSubject.next(true);
      if (res) {
        this.snackBar.open( +res.classroomCourseId === 0 ? 'La materia ha sido desenlazada exitosamente.'
          : 'La materia ha sido enlazada exitosamente.', null, {duration: 2500});
        this.actual = res.classroomCourseId;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.actual) {
      this.classroomSelectForm.setValue({classroomSelect: '' + changes.actual.currentValue}, {emitEvent: false});
    }
  }

  enlazarRequest(materias, accion, data) {
    const actual = this.actual;
    return this.classroomService.enlazarClassroomMcp(
      materias, accion, accion ? this.courses.find(item => item.id === data) : null).pipe(
        catchError(err => {
          this.savingSubject.next(true);
          this.classroomSelectForm.setValue({classroomSelect: actual}, {emitEvent: false});
          this.customAlertService.setCustomMessage({
            tipo: 'error',
            texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
          });
          return of(false);
        })
      );
  }

  desEnlazar() {
    this.savingSubject.next(false);
    this.enlazarRequest([this.materia], false, null).subscribe(
      res => {
        this.savingSubject.next(true);
        if (res) {
          this.snackBar.open( +res.classroomCourseId === 0 ? 'La materia ha sido desenlazada exitosamente.'
            : 'La materia ha sido enlazada exitosamente.', null, {duration: 2500});
          this.actual = res.classroomCourseId;
          this.savingSubject.next(true);
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.valueChangesSubscription.unsubscribe();
  }

}
